import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var getCertificateRes;
export const getCertificateTodo = createAsyncThunk('getCertificate', async (val) => {
    let user_id = JSON.parse(localStorage.getItem('user_data'))

    try {
        const res = await axios({

            method: "post",
            url: process.env.REACT_APP_API_URL + 'learner/dummy_pdf',
            data: {
                "user_id": user_id.vemp_code,
                "user_role": user_id.vrole_name,
                "fk_training_id": val?.fk_training_id,
                "course_id": val?.course_id,
                "learner_quiz_id": val?.learnerquizid,
                "training_id":val?.learnertrainingid,
                "device_token": user_id.vdevice_token
            },
            headers: { "Content-Type": "application/json", "Authorization": 'Bearer ' + user_id.access_token }
        })
        return getCertificateRes = res.data
    } catch (error) {
        return getCertificateRes = error.response.data
    }
})